import * as types from "../actions/actionTypes"
const initialState = {
  inProcess:{},
  error:{},
  data:{}
};

const notificationResponse = (state = initialState, action) => {
  let loadings = {...state.inProcess};
  let errors = {...state.error};
  switch (action.type) {
    case types.INVITATION_ACCEPT_REQUEST:
      errors[action.payLoad] = null;
      loadings[action.payLoad] = true;
      return { ...state, inProcess: loadings, error: errors };
    case types.INVITATION_ACCEPT_SUCCESS:
      errors[action.payLoad] = false;
      loadings[action.payLoad] = false;
      return { ...state, inProcess: loadings, error: errors};
    case types.INVITATION_ACCEPT_FAILURE:
      errors[action.payLoad] = true;
      loadings[action.payLoad] = false;
      return { ...state, inProcess: loadings, error: errors };

    case types.INVITATION_REJECT_REQUEST:
      errors[action.payLoad] = null;
      loadings[action.payLoad] = true;
      return { ...state, inProcess: loadings, error: errors};
    case types.INVITATION_REJECT_SUCCESS:
      errors[action.payLoad] = false;
      loadings[action.payLoad] = false;
      return { ...state, inProcess: loadings, error: errors};
    case types.INVITATION_REJECT_FAILURE:
      errors[action.payLoad] = true;
      loadings[action.payLoad] = false;
      return { ...state, inProcess: loadings, error: errors };

    case types.ANNOUNCEMENT_SHOW_REQUEST:
      errors[action.id] = null;
      loadings[action.id] = true;
      return { ...state, inProcess: loadings, error: errors };
    case types.ANNOUNCEMENT_SHOW_SUCCESS:
      errors[action.payLoad.id] = false;
      loadings[action.payLoad.id] = false;
      return { ...state, inProcess: loadings, error: errors, data:action.payLoad.data};
    case types.ANNOUNCEMENT_SHOW_FAILURE:
      errors[action.payLoad.id] = true;
      loadings[action.payLoad.id] = false;
      return { ...state, inProcess: loadings, error: errors };

    default:
      return state;
  }
};

export default notificationResponse;